
export default class ESP32PartitionType {
    partitionTypes = {
        0: 'APP',
        1: 'DATA',
    };
    appTypes = {
        0: 'factory',
        16: 'ota_0',
        17: 'ota_1',
        18: 'ota_2',
        19: 'ota_3',
        20: 'ota_4',
        21: 'ota_5',
        22: 'ota_6',
        23: 'ota_7',
        32: 'test',
    };
    dataTypes = {
        0: 'ota',
        1: 'phy',
        2: 'nvs',
        3: 'coredump',
        4: 'nvs_keys',
        5: 'efuse',
        6: 'undefined',
        128: 'esphttpd',
        129: 'fat',
        130: 'spiffs'
    };

    constructor(public name: string, 
        public type: number, 
        public subtype: number,
        public size: number, 
        public offset: number,
        public flags: number) {
    }
    public partitionTypeStr(): string {
        if (this.type in this.partitionTypes) {
            return (this.partitionTypes as any)[this.type];
        }
        return `Unknown (${this.type})`;
    }
    public subTypeStr(): string {
        if ((this.type === 0) && this.subtype in this.appTypes) {
            return (this.appTypes as any)[this.subtype];
        } else if ((this.type === 1) && this.subtype in this.dataTypes) {
            return (this.dataTypes as any)[this.subtype];
        }
        return `Unknown (${this.subtype})`;
    }
    public toStr(): string {
        return `${this.name}, (${this.partitionTypeStr()}, ${this.subTypeStr()}, 0x${this.offset.toString(16)}, 0x${this.size.toString(16)}, 0x${this.flags.toString(16)})`;
    }
}
